import React from "react";
import { connect } from 'react-redux';

import * as connectionActions from "../actions/connectionActions";
import { ConnectionTypeList } from "../constants/ConnectionType";

/**
 * Filtr do połączeń. Zawiera różne typy połączeń i w zależności od wybranego - filtrujemy wszystkie połączenia otrzymane z serwera.
 * Wybrany filtr jest zapisywany do reducera
 */
class ConnectionFilter extends React.PureComponent {

    /**
     * Wybór odpowiedniego filtru
     */
    onFilterItemClick = data => {
        this.props.onFilter(data);
    }

    render() {

        //renderujemy wszyskie typy połączenia
        //dodajemy styl indywidualnie dla kazdege elementu oraz styl wybranego elementu
        const buttonItems = ConnectionTypeList.map((item) =>
            <div key={item.id} className="w3-bar-item">
                <button className={`w3-btn width150 ${item.cssStyle} ${item.id === this.props.selectedConnectionType.id ? 'w3-bottombar' : ''}`} onClick={() => this.onFilterItemClick(item)}>
                    {item.boldStyle ? <b>{item.filterDisplayText}</b> : item.filterDisplayText}
                </button>
            </div>
        );

        return (

            <div className="w3-panel w3-padding">
                <div className="w3-bar">
                    {buttonItems}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedConnectionType: state.connectionReducer.selectedConnectionType
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFilter: connectionType => {
            dispatch(connectionActions.filterConnections(connectionType));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionFilter);